/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AcknowledgedSafetyCheck = {
  id: string;
  code?: string | undefined;
  message?: string | undefined;
};

/** @internal */
export const AcknowledgedSafetyCheck$inboundSchema: z.ZodType<
  AcknowledgedSafetyCheck,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  code: z.string().optional(),
  message: z.string().optional(),
});
/** @internal */
export type AcknowledgedSafetyCheck$Outbound = {
  id: string;
  code?: string | undefined;
  message?: string | undefined;
};

/** @internal */
export const AcknowledgedSafetyCheck$outboundSchema: z.ZodType<
  AcknowledgedSafetyCheck$Outbound,
  z.ZodTypeDef,
  AcknowledgedSafetyCheck
> = z.object({
  id: z.string(),
  code: z.string().optional(),
  message: z.string().optional(),
});

export function acknowledgedSafetyCheckToJSON(
  acknowledgedSafetyCheck: AcknowledgedSafetyCheck,
): string {
  return JSON.stringify(
    AcknowledgedSafetyCheck$outboundSchema.parse(acknowledgedSafetyCheck),
  );
}
export function acknowledgedSafetyCheckFromJSON(
  jsonString: string,
): SafeParseResult<AcknowledgedSafetyCheck, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AcknowledgedSafetyCheck$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AcknowledgedSafetyCheck' from JSON`,
  );
}
